import dayjs from 'dayjs';

export const isVisitMonthEqualWithCurrentOpenMonth = (
  visitDate: string,
  currentOpenMonth: string
): boolean => {
  const date = dayjs(visitDate, 'YYYY-MM-DD');
  const compareDate = dayjs(currentOpenMonth, 'YYYY-MM-DD');

  return date.year() === compareDate.year() && date.month() === compareDate.month();
};

export const isVisitMonthBeforeCurrentOpenMonth = (
  visitDate: string,
  currentOpenMonth: string
): boolean => {
  const date = dayjs(visitDate, 'YYYY-MM-DD');
  const compareDate = dayjs(currentOpenMonth, 'YYYY-MM-DD');

  return date.isBefore(compareDate);
};

export const isVisitMonthAfterCurrentOpenMonth = (
  visitDate: string,
  currentOpenMonth: string
): boolean => {
  const date = dayjs(visitDate, 'YYYY-MM-DD');
  const compareDate = dayjs(currentOpenMonth, 'YYYY-MM-DD');

  return date.isAfter(compareDate);
};
